import { initTagFilterCounts } from './tag-filter-counts.js';

function handlePreviewLinkClick(e) {
  e.preventDefault();

  const currentSection = e.currentTarget.closest('.modal__section');
  if (currentSection) {
    const currentContext = currentSection.getAttribute('data-context');
    if (currentContext) {
      const oppositeContext = currentContext === 'american' ? 'international' : 'american';
      const oppositeSection = document.querySelector(`.modal__section[data-context="${oppositeContext}"]`);
      if (oppositeSection) {
        oppositeSection.querySelectorAll('.aj__filter-preview.active').forEach(function (activeLink) {
          activeLink.classList.remove('active');
        });
        oppositeSection.querySelectorAll('[aria-expanded="true"]').forEach(function (expandedButton) {
          expandedButton.setAttribute('aria-expanded', 'false');
        });
      }
    }
  }

  const targetHref = e.currentTarget.getAttribute('href');
  const isActive = e.currentTarget.classList.contains('active');

  if (isActive) {
    e.currentTarget.classList.remove('active');
    selectedPreviewHref = window.location.pathname + window.location.search;
    handlePreviewFetch(selectedPreviewHref, e.currentTarget);
  } else {
    const activeLink = document.querySelector('.aj__filter-preview.active');
    if (activeLink) {
      activeLink.classList.remove('active');
    }
    e.currentTarget.classList.add('active');
    selectedPreviewHref = targetHref;
    handlePreviewFetch(targetHref, e.currentTarget);
  }
}

function handleToggleButtonClick(e) {
  var targetId = e.currentTarget.getAttribute('data-target');
  var targetElem = document.getElementById(targetId);
  var toggleButtons = document.querySelectorAll('.toggle-region');
  if (targetElem) {
    var isVis = targetElem.classList.contains('region-vis');
    if (isVis) {
      targetElem.classList.remove('region-vis');
      e.currentTarget.setAttribute('aria-expanded', 'false');
    } else {
      var allRegionVis = document.querySelectorAll('.region-vis');
      if (allRegionVis.length > 0) {
        allRegionVis.forEach(function (elem) {
          elem.classList.remove('region-vis');
        });
        setTimeout(function () {
          targetElem.classList.add('region-vis');
        }, 250);
      } else {
        targetElem.classList.add('region-vis');
      }

      if (toggleButtons.length > 0) {
        toggleButtons.forEach(function (button) {
          button.setAttribute('aria-expanded', 'false');
        });
      }
      e.currentTarget.setAttribute('aria-expanded', 'true');
    }
  } else {
    var allRegionVis = document.querySelectorAll('.region-vis');
    if (allRegionVis.length > 0) {
      allRegionVis.forEach(function (elem) {
        elem.classList.remove('region-vis');
      });
    }
    if (toggleButtons && toggleButtons.length > 0) {
      toggleButtons.forEach(function (button) {
        button.setAttribute('aria-expanded', 'false');
      });
    }
    e.currentTarget.setAttribute('aria-expanded', 'true');
  }

  const targetHref = e.currentTarget.getAttribute('data-url');
  document.querySelectorAll('.modal__filters--wrapper .aj__filter-preview.active').forEach(function (activeLink) {
    activeLink.classList.remove('active');
  });
  selectedPreviewHref = targetHref;

  handlePreviewFetch(targetHref, e.currentTarget);
}

function handleResultButtonClick(e) {
  const target = e.currentTarget.getAttribute('data-target-url');
  if (target) {
    window.location.href = target;
  } else {
    const activeModal = document.querySelector('.modal__filters--wrapper.modal-active');
    if (activeModal) {
      activeModal.classList.remove('modal-active');
    }
  }
}

function handlePreviewFetch(targetHref, clickedElement) {
  fetch(targetHref)
    .then((response) => response.text())
    .then((htmlString) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, 'text/html');

      if (
        clickedElement.classList.contains('update__grid-filters') ||
        clickedElement.parentElement.classList.contains('filterlink--within')
      ) {
        const currentFiltersList = document.querySelector('.tag-filters__list');
        const newFiltersList = doc.querySelector('.tag-filters__list');
        if (currentFiltersList && newFiltersList) {
          currentFiltersList.innerHTML = newFiltersList.innerHTML;
          // console.log(newFiltersList.innerHTML);
          initTagFilterPreview(); // reinitialize event listeners
          const tagFilterCounts = initTagFilterCounts({
            filterContainerSelector: '.tag-filters__list',
          });
        } else {
          console.warn('tag-filter-preview: No .tag-filters__list found on preview page.');
        }
      }

      const countElement = doc.querySelector('#resultcount');
      const resultButtons = document.querySelectorAll('.dynamic-get-item-count');
      if (countElement) {
        const count = parseInt(countElement.textContent.trim(), 10);
        if (!isNaN(count)) {
          if (resultButtons) {
            resultButtons.forEach(function (button) {
              button.textContent = count === 1 ? `Show ${count} item` : `Show ${count} items`;
              button.setAttribute('data-target-url', targetHref);
            });
          }
        }
      }
    })
    .catch((err) => {
      console.error('Error fetching preview target:', err);
    });
}

export function initTagFilterPreview() {
  var toggleButtons = document.querySelectorAll('.toggle-region');

  let selectedPreviewHref = null;

  const currModal = document.querySelector('.modal__filters--wrapper');
  const previewLinks = document.querySelectorAll('.aj__filter-preview, .filterlink--within a');
  const resultButtons = document.querySelectorAll('.dynamic-get-item-count');

  toggleButtons.forEach(function (button) {
    button.removeEventListener('click', handleToggleButtonClick);
    button.addEventListener('click', handleToggleButtonClick);
  });

  previewLinks.forEach(function (link) {
    link.removeEventListener('click', handlePreviewLinkClick); // unbind old
    link.addEventListener('click', handlePreviewLinkClick); // bind fresh
  });

  resultButtons.forEach(function (button) {
    button.removeEventListener('click', handleResultButtonClick);
    button.addEventListener('click', handleResultButtonClick);
  });
}
